/* Toggle for snippets/bioavailability-widget.liquid: sets data-mode and aria-pressed and swaps each
   stat's text from its data-standard / data-phytosome attribute. Loaded by how-it-works and
   roots-good-years only when the widget is enabled; re-inits on shopify:section:load. */
(function () {
  function initCard(card) {
    if (!card || card.dataset.hiwBioInit === '1') return;
    var btns = card.querySelectorAll('.hiw-bio__toggle-btn');
    if (btns.length < 2) return;
    var stats = card.querySelectorAll('[data-standard][data-phytosome]');

    function setMode(mode) {
      if (card.getAttribute('data-mode') === mode) return;
      card.setAttribute('data-mode', mode);
      btns.forEach(function (b) {
        var on = b.dataset.mode === mode;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      stats.forEach(function (el) {
        var next = mode === 'phytosome' ? el.getAttribute('data-phytosome') : el.getAttribute('data-standard');
        if (next != null) el.textContent = next;
      });
      if (mode === 'phytosome') {
        var lipid = card.querySelector('.hiw-bio__lipid');
        if (lipid) { lipid.style.animation = 'none'; void lipid.offsetHeight; lipid.style.animation = ''; }
      }
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.dataset.mode); });
    });
    card.dataset.hiwBioInit = '1';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.hiw-bio').forEach(initCard);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
